import type { RootState } from '../types/store';
import getSubscriptionList from './subscription-list';
import messenger from '../messenger';
import type { Subscription } from '../types/subscription';
import SubscriptionStatus from '../constants/subscription-status';
import isEcommercePlanType from '../verifiers/is-ecommerce-plan-type';

function getLastDeprovisionedEcommerceSubscription(state: RootState): Subscription | null {
  const subscriptions = getSubscriptionList(state);

  if (!subscriptions) throw new Error(messenger.missingData('subscriptions'));

  return subscriptions.reduce(
    (deprovisionedEcommerce: Subscription | null, subscription: Subscription) => {
      if (
        subscription.status === SubscriptionStatus.DEPROVISIONED &&
        isEcommercePlanType(subscription.type)
      ) {
        if (!deprovisionedEcommerce) {
          return subscription;
        }

        const subscriptionDeprovisionTime = new Date(subscription.deprovision_date).getTime();
        const lastDeprovisionedTime = new Date(deprovisionedEcommerce.deprovision_date).getTime();

        if (subscriptionDeprovisionTime > lastDeprovisionedTime) {
          return subscription;
        }

        if (subscriptionDeprovisionTime === lastDeprovisionedTime) {
          const subscriptionUpdateTime = new Date(subscription.updated_at).getTime();
          const lastDeprovisionedUpdateTime = new Date(deprovisionedEcommerce.updated_at).getTime();

          return subscriptionUpdateTime > lastDeprovisionedUpdateTime
            ? subscription
            : deprovisionedEcommerce;
        }
      }

      return deprovisionedEcommerce;
    },
    null
  );
}

export default getLastDeprovisionedEcommerceSubscription;
